/*
 * Velour — Hero carousel
 * Autoplay + ok + nokta + touch swipe. Theme editor uyumlu (custom element).
 * Tek-slide / carousel JS gerektirmediği durumlarda devreye girmez.
 */
(function () {
  'use strict';

  class VlHeroCarousel extends HTMLElement {
    constructor() {
      super();
      this.index = 0;
      this.timer = null;
      this._onVisibility = this._onVisibility.bind(this);
    }

    connectedCallback() {
      this.track = this.querySelector('[data-vl-hero-track]');
      this.slides = Array.from(this.querySelectorAll('[data-vl-hero-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-vl-hero-dot]'));
      this.prevBtn = this.querySelector('[data-vl-hero-prev]');
      this.nextBtn = this.querySelector('[data-vl-hero-next]');

      if (this.slides.length < 2) return;

      this.autoplay = this.dataset.autoplay === 'true';
      this.interval = parseInt(this.dataset.interval, 10) || 6000;

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(this.index - 1, true));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(this.index + 1, true));

      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => this.go(i, true));
      });

      this._bindSwipe();
      this._bindKeys();

      document.addEventListener('visibilitychange', this._onVisibility);
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());

      this.go(0, false);
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      document.removeEventListener('visibilitychange', this._onVisibility);
    }

    _onVisibility() {
      if (document.hidden) {
        this.stop();
      } else {
        this.start();
      }
    }

    go(next, userTriggered) {
      const total = this.slides.length;
      this.index = ((next % total) + total) % total;

      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      this.dots.forEach((dot, i) => {
        const active = i === this.index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
        dot.setAttribute('tabindex', active ? '0' : '-1');
      });

      if (userTriggered) {
        this.start();
      }
    }

    start() {
      if (!this.autoplay || this.slides.length < 2) return;
      this.stop();
      this.timer = window.setInterval(() => this.go(this.index + 1, false), this.interval);
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    _bindKeys() {
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          this.go(this.index - 1, true);
        } else if (e.key === 'ArrowRight') {
          this.go(this.index + 1, true);
        }
      });
    }

    _bindSwipe() {
      let startX = 0;
      let startY = 0;
      let tracking = false;

      const surface = this.track || this;

      surface.addEventListener(
        'touchstart',
        (e) => {
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          tracking = true;
        },
        { passive: true }
      );

      surface.addEventListener(
        'touchend',
        (e) => {
          if (!tracking) return;
          tracking = false;
          const dx = e.changedTouches[0].clientX - startX;
          const dy = e.changedTouches[0].clientY - startY;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
            this.go(dx < 0 ? this.index + 1 : this.index - 1, true);
          }
        },
        { passive: true }
      );
    }
  }

  if (!customElements.get('vl-hero-carousel')) {
    customElements.define('vl-hero-carousel', VlHeroCarousel);
  }
})();
